import {
    sizeReducers,
    graphReducer,
    activePreviewSymbolSymbolReducer,
    selectSymbolReducers,
    schematicListReducer,
    setSymbolsTypes,
    setSidebarVisibility,
    setSchematicDocument,
    setLoading,
    setDraft,
    setBackgrounds,
    setSchematicType
} from './reducers';
import {
    LogOut,
    Draft,
} from "./actions";
import LocalStorageService from "../../localStorage-service";


const defaultState = {
    previewSymbol: null,
    gridStep: 10,
    graph: {
        value: null
    },
    selectedSymbol: null,
    schematicList: [],
    symbolsTypes: [],
    sidebarVisible: false,
    schematicDocument: null,
    backgrounds: [],
    loaders: [],
    activeSchematicType: null,
};

function schematicReducers(state = defaultState, action) {
    if (action.type === LogOut.SET_LOG_OUT) {
        LocalStorageService.logOut();
        return defaultState
    } else if (action.type === Draft.SET_DRAFT) {
        return setDraft(state, action)
    }
    return {
        previewSymbol: activePreviewSymbolSymbolReducer(state.previewSymbol, action),
        gridStep: sizeReducers(state.gridStep, action),
        graph: graphReducer(state.graph, action),
        selectedSymbol: selectSymbolReducers(state.selectedSymbol, action),
        schematicList: schematicListReducer(state.schematicList, action),
        symbolsTypes: setSymbolsTypes(state.symbolsTypes, action),
        sidebarVisible: setSidebarVisibility(state.sidebarVisible, action),
        schematicDocument: setSchematicDocument(state.schematicDocument, action),
        backgrounds: setBackgrounds(state.backgrounds, action),
        loaders: setLoading(state.loaders, action),
        activeSchematicType: setSchematicType(state.activeSchematicType, action)
    }
}


export default schematicReducers